import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TaskCount } from '@Types/common/TaskCount';
import { RequestCount } from '@Types/index';

interface HeaderState {
  requestsCount: RequestCount[];
  tasksCount: TaskCount[];
}

const initialState: HeaderState = {
  requestsCount: [],
  tasksCount: [],
};

const headerSlice = createSlice({
  name: 'header',
  initialState,
  reducers: {
    setRequestsCount: (
      state: HeaderState,
      action: PayloadAction<RequestCount[]>
    ) => {
      state.requestsCount = action.payload;
    },
    setTasksCount: (state: HeaderState, action: PayloadAction<TaskCount[]>) => {
      state.tasksCount = action.payload;
    },
  },
});

const { actions } = headerSlice;

export const headerActions = {
  ...actions,
};

export default headerSlice;
